import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components'
import previous from '../assets/previous.png'

const Error = () => {
    return (
        <Container>
            <Previous to="/" >Previous</Previous>
            <SubTitle>Continental Car & Van tires</SubTitle>
            <Title>Sorry, we could not find a fitting tire.</Title>
            <Text>Unfortunately, we could not find a suitable tire for that number. Try the option “Search by size” or look under “All tires" to find the fitting tire.</Text>

            <div>
                <Button>
                    <p>Search by size</p>
                </Button>
                <Button to="/alltires">
                    <p>All tires</p>
                </Button>
            </div>
        </Container>
    );
}

const Container = styled.div`
    width: 90%;
    padding-top: 50px;
    margin: 0 auto;
    text-align: center;
`
const SubTitle = styled.p`
    font-family: ContinentalMedium;
    font-size: 16px;
    margin-bottom: 5px;
`
const Title = styled.p`
    font-family: ContinentalMedium;
    width: 279px;
    margin: 0 auto;
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 20px;
`
const Text = styled.p`
    font-size: 18px;
    font-height: 24px;
    width: 327px;
    margin: 0 auto;
    margin-bottom: 150px;
`
const Button = styled(Link)`
    width: 250px;
    height: 50px;
    border: 2px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 30px;
    font-family: ContinentalMedium;
    font-size: 18px;
    letter-spacing: 0.005em;
    color: black;
    text-decoration: none;
`
const Previous = styled(Link)`
    position: absolute;
    font-family: ContinentalBook;
    top: 95px;
    left: 5%;
    color: black;
    text-decoration: none;
    &:before {
        background-image: url(${previous});
        background-size: 7px 13px;
        display: inline-block;
        width: 7px; 
        height: 13px;
        content:"";
        margin-right: 13px;
    }
`
export default Error;